.pending-suggested-reply {
    padding: 8px;
    border-radius: 3px;
    border: 1.5px solid var(--form-border);
    background-color: var(--off-white);
    max-height: 90px;
    overflow-y: auto;
    user-select: none;
}
